var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-block"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"search"},[_vm._t("search")],2),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)]),_c('div',{staticClass:"main_content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }